document.addEventListener('DOMContentLoaded', function () {
  // Preserve the v2 short-description punctuation cleanup.
  document.querySelectorAll('.short-desc').forEach(function (el) {
    var nodes = Array.from(el.childNodes);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.nodeType === Node.TEXT_NODE && n.nodeValue.trim().length) {
        n.nodeValue = n.nodeValue.replace(/^\s*(?:["'“”‘’]\s*)?[:;\-–—]+\s*/, '');
        break;
      }
    }
  });

  // Preserve the v2 fallback that injects Preview Script if the theme block misses it.
  if (!document.querySelector('.btn-preview-inline')) {
    var row = document.querySelector('.buttons-single-row');
    if (row) {
      var sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('section_id', 'gv-preview-button');
      fetch(sectionUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (document.querySelector('.btn-preview-inline')) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var preview = doc.querySelector('.gv-preview-script-injected');
          if (preview) row.appendChild(preview);
        })
        .catch(function () {});
    }
  }

  var modal = null;
  var frame = null;
  var buyButton = null;
  var priceEl = null;
  var productTitleEl = null;
  var fallbackLink = null;
  var lastFocused = null;
  var currentPreviewUrl = '';
  var cartResetTimer = null;

  function ensureModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'gv-script-reader';
    modal.id = 'gvScriptReader';
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = [
      '<div class="gv-script-reader__backdrop" data-gv-reader-close></div>',
      '<div class="gv-script-reader__dialog" role="dialog" aria-modal="true" aria-labelledby="gvReaderTitle">',
        '<header class="gv-script-reader__header">',
          '<button type="button" class="gv-script-reader__back" data-gv-reader-close aria-label="Back to product">← <span>Back to product</span></button>',
          '<div class="gv-script-reader__heading">',
            '<div class="gv-script-reader__kicker">SCRIPT PREVIEW</div>',
            '<div class="gv-script-reader__title" id="gvReaderTitle"></div>',
          '</div>',
          '<a class="gv-script-reader__external" href="#" target="_blank" rel="noopener">Open PDF</a>',
          '<button type="button" class="gv-script-reader__close" data-gv-reader-close aria-label="Close preview">×</button>',
        '</header>',
        '<main class="gv-script-reader__body">',
          '<div class="gv-script-reader__notice">Watermarked preview · Read here without leaving the store</div>',
          '<iframe class="gv-script-reader__frame" title="Script preview" loading="lazy"></iframe>',
        '</main>',
        '<footer class="gv-script-reader__buybar">',
          '<div class="gv-script-reader__buycopy">',
            '<div class="gv-script-reader__prompt">Like this script?</div>',
            '<div class="gv-script-reader__buytitle"></div>',
          '</div>',
          '<div class="gv-script-reader__price"></div>',
          '<button type="button" class="gv-script-reader__atc">Add to Cart</button>',
        '</footer>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);
    frame = modal.querySelector('.gv-script-reader__frame');
    buyButton = modal.querySelector('.gv-script-reader__atc');
    priceEl = modal.querySelector('.gv-script-reader__price');
    productTitleEl = modal.querySelector('.gv-script-reader__buytitle');
    fallbackLink = modal.querySelector('.gv-script-reader__external');

    modal.querySelectorAll('[data-gv-reader-close]').forEach(function (button) {
      button.addEventListener('click', closeReader);
    });

    buyButton.addEventListener('click', function () {
      var mainAdd = document.querySelector('.main-product-form .btn-add-to-cart-inline');
      if (!mainAdd || mainAdd.disabled) return;

      buyButton.disabled = true;
      buyButton.textContent = 'Adding…';

      var settled = false;
      function resetButton(success) {
        if (settled) return;
        settled = true;
        if (cartResetTimer) window.clearTimeout(cartResetTimer);
        if (success) {
          buyButton.textContent = 'Added ✓';
          window.setTimeout(function () {
            buyButton.textContent = 'Add to Cart';
            buyButton.disabled = false;
          }, 1800);
        } else {
          buyButton.textContent = 'Add to Cart';
          buyButton.disabled = false;
        }
      }

      document.addEventListener('cart:updated', function () { resetButton(true); }, { once: true });
      cartResetTimer = window.setTimeout(function () { resetButton(false); }, 6000);
      mainAdd.click();
    });

    return modal;
  }

  function previewSrc(url) {
    if (!url) return '';
    var base = url.split('#')[0];
    return base + '#toolbar=0&navpanes=0&view=FitH';
  }

  function openReader(link) {
    var href = link && link.href ? link.href : '';
    if (!href) return;

    ensureModal();
    lastFocused = document.activeElement;
    currentPreviewUrl = href;

    var title = document.querySelector('.main-product-title');
    var price = document.querySelector('.main-price');
    var modalHeading = modal.querySelector('.gv-script-reader__title');
    var name = title ? title.textContent.trim() : 'Script Preview';

    modalHeading.textContent = name;
    productTitleEl.textContent = name;
    priceEl.textContent = price ? price.textContent.trim() : '';
    fallbackLink.href = href;

    var mainAdd = document.querySelector('.main-product-form .btn-add-to-cart-inline');
    if (!mainAdd) {
      buyButton.hidden = true;
      priceEl.hidden = true;
      modal.querySelector('.gv-script-reader__buycopy').style.gridColumn = '1 / -1';
    } else {
      buyButton.hidden = false;
      priceEl.hidden = false;
      buyButton.disabled = !!mainAdd.disabled;
      buyButton.textContent = mainAdd.disabled ? 'Unavailable' : 'Add to Cart';
    }

    if (frame && frame.src !== previewSrc(href)) frame.src = previewSrc(href);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gv-reader-open');
    document.body.classList.add('gv-reader-open');
    window.setTimeout(function () {
      var close = modal.querySelector('.gv-script-reader__close');
      if (close) close.focus();
    }, 0);
  }

  function closeReader() {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gv-reader-open');
    document.body.classList.remove('gv-reader-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  // Delegation also catches a fallback preview button injected after page load.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.btn-preview-inline');
    if (!link || !link.href) return;

    // On real mobile devices (and narrow mobile layouts), keep the original
    // GodsVerse-hosted PDF link behavior instead of opening the in-store iframe.
    var useDirectMobilePreview =
      /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      window.matchMedia('(max-width: 700px)').matches;

    if (useDirectMobilePreview) return;

    event.preventDefault();
    openReader(link);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) closeReader();
  });
});